module.exports = __webpack_public_path__ + "static/img/7.4b8b129.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/13/zh/7.png
// module id = ga9F
// module chunks = 0